import { Box, Card, CardContent, Divider, useMediaQuery, useTheme } from "@mui/material";
import { FormConfirmingSpinner } from "./partial/form-confirming-spinner.partial";
import { VehicleInformationCardContents } from "./vehicle-information-card-contents.component";
import { NotSerializedBookingInputs } from "../../features/Booking-Form/typings/booking-inputs";
import { EnlargedImageCarousel } from "../../features/EnlargedImageCarousel/enlarged-image-carousel.component";
import { normalizePicturePaths } from "./functions/normalizePicturePaths.function";

type P = {
  confirmingBooking: boolean;
  bookingInputs: NotSerializedBookingInputs;
};

export const FormVehicleConfirm: React.FC<P> = ({ confirmingBooking, bookingInputs }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const vehicle = bookingInputs.bookedVehicle;

  if (!vehicle || confirmingBooking) return <FormConfirmingSpinner />;

  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        borderRadius: 2,
        mt: 1,
        border: theme => `1px solid ${theme.palette.divider}`
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          minHeight: 0
        }}
      >
        {/* Left: vehicle characteristics */}
        <CardContent
          sx={{
            flex: { xs: "0 0 auto", md: "1 1 50%" },
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            pb: { xs: 0, md: 3 }
          }}
        >
          <VehicleInformationCardContents vehicleInfo={vehicle} isCalendarDisplay={false} />
        </CardContent>

        <Divider sx={{ display: { xs: "block", md: "none" } }} />

        {/* Right: pictures — full-width on mobile with larger carousel */}
        <Box
          sx={{
            flex: { xs: "0 0 auto", md: "0 0 40%" },
            minWidth: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: { xs: 3, md: 2 }
          }}
        >
          <EnlargedImageCarousel
            picturePaths={normalizePicturePaths(vehicle.picturePaths)}
            isLoading={false}
            imageSize={isMobile ? 36 : 28}
            boxSize={isMobile ? 42 : 32}
          />
        </Box>
      </Box>
    </Card>
  );
};
